module.exports = __webpack_public_path__ + "media/images/digivent/digivent_white-af549e49ffa6902aa814ee8e58091103.png";